module.exports = __webpack_public_path__ + "img/album-HallToTheThief.d71db3fb.jpg";